import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, Lock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_nordic-cruise-launch/artifacts/ae74l9ew_DUNDER%20LOGO%20SMOKE.png";

export default function AdminLoginForm({ password, setPassword, onSubmit, isLoading }) {
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-[200px] mb-8">
        <img 
          src={LOGO_URL} 
          alt="Dunderkryssningen Logo"
          className="w-full drop-shadow-[0_0_15px_rgba(255,215,0,0.15)]"
          data-testid="admin-logo"
        />
      </div>

      <div 
        className="w-full max-w-sm bg-[#0A0A0A] border border-[#222] p-6 md:p-8"
        data-testid="admin-login-container"
      >
        <div className="flex items-center justify-center mb-6">
          <div className="w-12 h-12 rounded-full bg-[#FFD700]/20 flex items-center justify-center">
            <Lock className="w-6 h-6 text-[#FFD700]" />
          </div>
        </div>
        
        <h1 className="font-heading text-2xl text-white uppercase text-center mb-6">
          Admin Login
        </h1>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label 
              htmlFor="password"
              className="text-xs font-bold uppercase tracking-widest text-[#FFD700] mb-2 block text-left"
            >
              Lösenord
            </label>
            <Input
              id="password"
              type="password"
              placeholder="Ange lösenord"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-[#1A1A1A] border-none text-white placeholder:text-gray-600 focus:ring-2 focus:ring-[#FFD700] h-12 rounded-sm"
              data-testid="admin-password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={isLoading}
            className="w-full bg-[#FFD700] text-black font-bold uppercase tracking-widest hover:bg-[#E5C100] h-12 rounded-sm"
            data-testid="admin-login-button"
          >
            {isLoading ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
              "Logga in"
            )}
          </Button>
        </form>
      </div>
    </div>
  );
}
